import { atom } from 'jotai';

import { extractAnimaticRefs } from '@/features/equipment-browser/extract-refs';
import {
  mapReadingRefsToSubscriptionIdentifiers,
  mapSettingRefsToSubscriptionIdentifiers,
} from '@/features/equipment-browser/subscriptions/map-to-subscription-identifiers';
import { SubscriptionIdentifier } from '@/hooks/query-hooks/gaia-api/use-subscription-base';

import { equipmentResponseAtom } from './equipment-response.state';

export const getAnimaticReadingsIdentifiersAtom = atom<SubscriptionIdentifier[]>((get) => {
  const equipment = get(equipmentResponseAtom);
  return mapReadingRefsToSubscriptionIdentifiers(
    extractAnimaticRefs(equipment?.animatic, false),
    'animatic-reading'
  );
});
getAnimaticReadingsIdentifiersAtom.debugLabel = 'getAnimaticReadingsIdentifiersAtom';

export const getAnimaticSettingsIdentifiersAtom = atom<SubscriptionIdentifier[]>((get) => {
  const equipment = get(equipmentResponseAtom);
  return mapSettingRefsToSubscriptionIdentifiers(
    extractAnimaticRefs(equipment?.animatic, true),
    'animatic-setting'
  );
});
getAnimaticSettingsIdentifiersAtom.debugLabel = 'getAnimaticSettingsIdentifiersAtom';
